import { createQueryKeys } from '@lukemorales/query-key-factory';

export const billing = createQueryKeys('billing', {
  me: null,
  uaeTeamOffer: null,
});
